function insertBeforeAtIndex(newElement: HTMLElement, referenceElement: HTMLElement, index: number = 0): void {
    referenceElement.insertBefore(newElement, referenceElement.children[index]);
}

// ----------------------------------------------------------------------------

export default insertBeforeAtIndex;
